import React from "react";
import { NumericFormat } from "react-number-format";

type Props = {
	price: number | string;
	decimalUpto?: number;
	allowNegative?: boolean;
};

const PriceDisplay: React.FC<Props> = (props: Props) => {
	const { price, decimalUpto = 2, allowNegative = true } = props;

	return (
		<span className="text-nowrap">
			<NumericFormat
				value={price}
				displayType={"text"}
				thousandSeparator={true}
				prefix={"₹ "}
				decimalScale={decimalUpto}
				fixedDecimalScale={true}
				renderText={(value) => value}
				thousandsGroupStyle="lakh"
				allowNegative={allowNegative}
			/>
		</span>
	);
};
export default PriceDisplay;
